// Функция синхронизации UI с корзиной при загрузке страницы
window.syncCartUIState = async function () {
	try {
		const res = await fetch("/cart.js");
		const cart = await res.json();

		// Создаем Map variant_id -> quantity
		const cartQuantities = new Map();
		cart.items.forEach(item => {
			cartQuantities.set(item.variant_id.toString(), item.quantity);
		});

		// Обновляем все quantity компоненты custom-quantity-add-to-cart
		document.querySelectorAll('custom-quantity-add-to-cart').forEach(element => {
			const productId = element.dataset.productId;
			if (productId) {
				const qty = cartQuantities.get(productId) || 0;
				element.setQuantity(qty);
			}
		});

		// Обновляем все обычные rc-quantity-input элементы в карточках
		document.querySelectorAll('[data-product-card]').forEach(card => {
			const vatCompleted = card.getAttribute('data-vat-completed') === 'true';
			const variantWithVat = card.getAttribute('data-variant-with-vat');
			const variantWithoutVat = card.getAttribute('data-variant-without-vat');
			
			// Определяем какой вариант активен
			const activeVariantId = vatCompleted && variantWithoutVat ? variantWithoutVat : variantWithVat;
			
			// Получаем количество из корзины для активного варианта
			const qty = cartQuantities.get(activeVariantId) || 0;
			
			// Находим инпут и обновляем его значение
			const input = card.querySelector('.rc-quantity-input');
			if (input) {
				input.value = qty;
			}
		});

		// Синхронизируем upgrade карточки
		const selectedUpgrade = cart.attributes?.selected_upgrade || '';
		document.querySelectorAll('.custom-product-upgrade-card').forEach(card => {
			const upgradeId = card.dataset.upgradeId || '';
			const isSelected = selectedUpgrade === upgradeId;
			
			if (isSelected) {
				card.classList.add('selected-upgrade');
			} else {
				card.classList.remove('selected-upgrade');
			}

			// Обновляем кнопку и визуальные элементы
			const btn = card.querySelector('.upgrade-btn');
			const selectedGroup = card.querySelector('.upgrade-selected-group');
			const dotSeparator = card.querySelector('.upgrade-dot-separator');
			
			if (btn) btn.textContent = isSelected ? 'Remove' : 'Upgrade';
			if (selectedGroup) selectedGroup.style.display = isSelected ? 'flex' : 'none';
			if (dotSeparator) dotSeparator.style.display = isSelected ? 'block' : 'none';
		});

		console.log('✅ Cart UI state synced');
	} catch (err) {
		console.error("Error syncing cart UI state:", err);
	}
};

window.updateCustomCartSummary = async function () {
	const currency = "£";
	try {
		const res = await fetch("/cart.js");
		const cart = await res.json();

		document.querySelector(
			"[data-summary-quantity]"
		).textContent = `(${cart.item_count} items)`;
		document.querySelector("[data-subtotal]").textContent =
			currency + (cart.original_total_price / 100).toFixed(2);
		document.querySelector("[data-total-rc]").textContent =
			currency + (cart.total_price / 100).toFixed(2);


		let discount = 0;
		if (cart.discount_applications.length > 0) {
			discount = cart.discount_applications.reduce(
				(sum, d) => sum + d.total_allocated_amount,
				0
			);
		}
			document.querySelector("[data-discount]").textContent =
			currency + (discount / 100).toFixed(2);
	} catch (err) {
		console.error("Error updating cart summary:", err);
	}
};

document.addEventListener("DOMContentLoaded", async function() {
	await window.syncCartUIState();
	await window.updateCustomCartSummary();
});

document.addEventListener("click", async (e) => {
	if (e.target.matches("#clear-cart-rc")) {
		await fetch("/cart/clear.js", { method: "POST" });

		await fetch("/cart/update.js", {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({ attributes: { vat_form_completed: null, selected_upgrade: null } }),
		});

		localStorage.removeItem("VatReliefDeclaration");

		document.querySelector("[data-summary-quantity]").textContent = `(0 items)`;
		document.querySelector("[data-subtotal]").textContent = "£0.00";
		document.querySelector("[data-discount]").textContent = "£0.00";
		document.querySelector("[data-total-rc]").textContent = "£0.00";

		// Сбрасываем все компоненты на 0
		document
			.querySelectorAll("custom-quantity-add-to-cart")
			.forEach((el) => el.resetQuantity());

		// Сбрасываем атрибуты VAT на всех карточках
		document.querySelectorAll('.custom-product-upgrade-card').forEach(card => {
			card.removeAttribute('data-vat-completed');
			card.classList.remove('selected-upgrade');
		});
		document.querySelectorAll('.custom-product-offer-card').forEach(card => {
			card.removeAttribute('data-vat-completed');
		});

		// Переключаем визуальное отображение обратно на "Including VAT"
		$(".custom-product-offer-card, .custom-product-upgrade-card").each(function () {
			const $withVat = $(this).find('[data-price-type="with-vat"]');
			const $withoutVat = $(this).find('[data-price-type="without-vat"]');

			$withVat.removeClass("price-inactive").addClass("price-active");
			$withoutVat.removeClass("price-active").addClass("price-inactive");
		});

		// Вызываем updateVatPrices для переключения variant ID на кнопках
		if (typeof updateVatPrices === 'function') {
			updateVatPrices(false); // false = переключить на Including VAT
		}

		// Синхронизируем UI вместо перезагрузки
		await window.syncCartUIState();
		
		console.log('✅ Cart cleared and UI reset');
	}
});
